module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/qDvqQb9dtrNCceoud9OsU-32fa0e5fefe2abed4806e33aca0c535d.jpg";